"use client";
import React from "react";
import Image from "next/image";

import square_shape_top from "@/assets/img/bg/square-shape-full.png";

//import marie_ellis_avatar from "@/assets/img/marie-ellis-rect.jpg";
import marie_ellis_avatar from "@/assets/img/marie-ellis-headshot-new-2.jpg";
import { scroller } from "react-scroll";
import { Icon } from "@/svg/Icon";

const scrollTo = () => {
  scroller.scrollTo("about-info-area", {
    duration: 800,
    delay: 0,
    smooth: "easeInOutQuart",
  });
};

const MuseHeroArea = () => {
  return (
    <section id="top">
      <div className="ab-hero__area ab-hero__ptb p-relative z-index-1 fix">
        <div className="ab-hero__shape-1">
          <Image src={square_shape_top} alt="image-here" />
        </div>

        <div className="smooth">
          <a onClick={scrollTo} className="d-none d-xl-block pointer">
            <div className="ab-hero__scroll-down">
              <span className="text">Scroll</span>
              <span>
                <Icon name="ScrollDownArrow" />
              </span>
            </div>
          </a>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-6  col-lg-5 col-xl-4">
              <Icon name="LogoMuseSquareFull" />
            </div>
            <div className="col-6 col-lg-5 col-xl-4 ">
              <div
                className="ab-hero__right-box text-end p-relative wow tpfadeLeft"
                data-wow-duration=".9s"
                data-wow-delay=".5s"
              >
                <div className="ab-hero__big-img">
                  <Image
                    src={marie_ellis_avatar}
                    style={{ height: "auto" }}
                    alt="Marie Ellis headshot"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MuseHeroArea;
